
import Vue from "vue";

export default Vue.extend({
  name: "AiReportMetricCard",
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    progress: {
      type: Number,
      default: 0
    }
  }
});
